export default __webpack_public_path__ + "static/media/Proveedores_Formato_de_aclaraciones.e1f0bece.xlsx";